import { PopupMenu } from '@tblabs/truffle';
import { Translations } from '../../Translations/Translations';
import { Svg } from '../../Components/General/Svg';
import { Icons } from '../../Components/Icons';
import { AppSettingsWindow } from '../../Windows/AppSettingsWindow';
import { CameraSettingsWindow } from "../../Windows/CameraSettingsWindow";
import { AppSettings } from '../../Services/AppSettings';
import { Beepers } from '../../Services/Beepers';


export class HeaderMenuBox extends PopupMenu
{
    constructor(_lang: Translations, _settings: AppSettings, _beepers: Beepers, _camera: ICamera)
    {
        const menu = {
            ["🐾 " + _lang.Help.value]: () => window.open("https://tutorial.specteam.pl", "_blank"),
            ["💻 " + _lang.AppSettings]: () => new AppSettingsWindow(_lang, _settings, _beepers),
            ["🎥 " + _lang.CameraSettings]: () => new CameraSettingsWindow(_lang, _camera),
            ["🔒 " + _lang.Logout]: () => window.location.hash = "login",
        };
        const button = new Svg(Icons.Menu2).RemoveAllClasses().Class("");

        super(menu, button);
    }
}
